import { ALL_CATS } from "@/i18n/slugs";

export const projectTypeLabels = Object.fromEntries(ALL_CATS.map((c) => [c.key, c.fr.name]));

export const statusLabels = {
  new: { label: "Nouveau", class: "badge-new" },
  assigned: { label: "Vendu", class: "badge-assigned" },
  contacted: { label: "Contacté", class: "badge-contacted" },
  pending: { label: "En attente", class: "badge-pending" },
  inactive: { label: "Inactif", class: "badge-pending" },
  rejected: { label: "Refusé", class: "bg-red-100 text-red-700" }
};
